import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirecionar para dashboard após alguns segundos
    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  if (!user) {
    return <div>Carregando...</div>;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      textAlign: 'center'
    }}>
      <div style={{
        backgroundColor: '#10b981',
        color: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <h1 style={{ margin: '0 0 20px 0', fontSize: '2rem' }}>🎉 Pagamento Aprovado!</h1>
        <p style={{ margin: '0 0 20px 0', fontSize: '1.1rem' }}>
          Seu plano Premium foi ativado com sucesso!
        </p>
        <p style={{ margin: '0', fontSize: '0.9rem', opacity: 0.9 }}>
          Você será redirecionado automaticamente em alguns segundos...
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            marginTop: '20px',
            padding: '12px 24px',
            backgroundColor: 'white',
            color: '#10b981',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Ir para Dashboard
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;